import agencyApi from 'api/agencyApi';
import AccountHelper from 'features/Account/accountHelper';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import CoinvestorInvestmentInfo from 'features/ManageCoinvestor/components/CoinvestorInvestmentInfo';
import AgencyInfoView from 'features/ManageDealer/components/EditAgencyView/AgencyInfoView';
import ChargepointCommissionView from 'features/ManageDealer/components/EditAgencyView/ChargepointCommissionView';
import EnergyCommissionView from 'features/ManageDealer/components/EditAgencyView/EnergyCommissionView';
import LandlordCommissionView from 'features/ManageDealer/components/EditAgencyView/LandlordCommissionView';
import PackageCommissionView from 'features/ManageDealer/components/EditAgencyView/PackageCommissionView';
import AffiliateSaleCommissionView from 'features/ManageDealer/components/EditAgencyView/AffiliateSaleCommissionView';
import SaleCommissionView from 'features/ManageDealer/components/EditAgencyView/SaleCommissionView';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { Formik } from 'formik';
import { AppDialogHelper } from 'general/components/AppDialog';
import AppTabs from 'general/components/AppTabs';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import CustomAlert from 'general/components/Others/CustomAlert';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import agencyBankHelper from 'general/helpers/agencyBankHelper';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

function EditAgencyScreen(props) {
  const { t } = useTranslation();
  const router = useRouter();
  const agencyId = router.query?.agencyId;
  const app = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const { agencyRole, isAddSubAgency = false } = props;
  const refFormik = useRef();
  const [readyToValidData, setReadyToValidData] = useState(false);
  const [operatorList, setOperatorList] = useState([]);
  const [commission, setCommission] = useState();
  const [commissionUnit, setCommissionUnit] = useState('');
  const [salesCommission, setSalesCommission] = useState();
  const [salesEnergyCommission, setSalesEnergyCommission] = useState();
  const [salesCommissionUnit, setSalesCommissionUnit] = useState('');
  const [bankList, setBankList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(t(`agencyInfo_${agencyRole}`));
  const [imageSrc, setImageSrc] = useState([null, null]);
  const [agencyList, setAgencyList] = useState([]);
  const [agencyDetail, setAgencyDetail] = useState();
  const [parentAgencyDetail, setParentAgencyDetail] = useState();
  const [commissionRateSale, setCommissionRateSale] = useState(0);
  const [commissionRateCoinvestor, setCommissionRateCoinvestor] = useState(0);
  const [commissionRateGroup, setCommissionRateGroup] = useState(0);
  const [commissionRateChargePoint, setCommissionRateChargePoint] = useState(0);
  const [commissionGrounds, setCommissionGrounds] = useState([]);
  const [isEnergyCommissionOn, setIsEnergyCommissionOn] = useState(false);
  const [isLandlordCommissionOn, setIsLandlordCommissionOn] = useState(true);
  const [landlordCommissionChange, setLandlordCommissionChange] = useState(false);
  const [hasSaleCommission, setHasSaleCommission] = useState(false);

  const [coinvestorEnergyCommission, setCoinvestorEnergyCommission] = useState();
  const [energyCoinvestorCommissionUnit, setEnergyCoinvestorCommissionUnit] = useState('');
  const [isEnergyCoinvestorCommissionOn, setIsEnergyCoinvestorCommissionOn] = useState(false);

  const [uploadFile, setUploadFile] = useState(false);
  const defaultSaleKPI = app?.appConfig?.config?.find(item => item.key === "defaultSaleKPI")?.value;
  const defaultPackageKPI = app?.appConfig?.config?.find(item => item.key === "defaultPackageKPI")?.value;
  const mainUser = useMemo(() => {
    return agencyDetail?.users?.find(user => user?.email === agencyDetail?.email) ?? null
  }, [agencyDetail]);

  const isAgencyInfo = useMemo(() => {
    return Number(agencyId) === user?.agency?.agencyId;
  }, [user, agencyId])

  const agencyBank = useMemo(() => {
    return agencyDetail?.bankAccounts?.find(bank => !!bank.defaultAccount && bank.status === 'VALIDATED');
  }, [agencyDetail])

  const hasSignedContract = useMemo(
    () => (agencyDetail?.numberOfSignedContracts ?? 0) > 0,
    [agencyDetail]
  );

  const showInvestorContractTabs = (agencyRole === 'INVESTOR' || agencyRole === 'COINVESTOR') && hasSignedContract;
  const showSaleCommissionSections = hasSaleCommission || showInvestorContractTabs;

  const adminRole = _.isEmpty(user)
    ? true
    : user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

  const isDisabled = useMemo(() => {
    if (!agencyId || adminRole || isAddSubAgency || !agencyDetail || !parentAgencyDetail || !user?.agency) return false;

    const hasEditPermission = DealerHelper.checkSaleHasEditPermission(
      agencyDetail,
      parentAgencyDetail,
      user?.agency
    );

    const hasContractRestriction = agencyDetail?.numberOfSignedContracts > 0 &&
      !adminRole &&
      Number(user?.agency?.agencyId) !== Number(agencyId);

    return !hasEditPermission || hasContractRestriction;
  }, [user, agencyDetail, adminRole, agencyId, parentAgencyDetail]);

  const [isAdminAgency, setAdminAgency] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const [filterAgencyList, setFilterAgencyList] = useState({
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    parentAgencyId: isAddSubAgency ? agencyId : '',
    role: adminRole ? (agencyRole === 'SALE' ? 'SALE' : '') : user?.agency?.primaryRole,
  });

  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();

  const appConfig = useAppConfig();
  useEffect(() => {
    setCommissionRateSale((appConfig.commissionRateSale * 100).toFixed(0));
    setCommissionRateCoinvestor((appConfig.commissionRateCoinvestor * 100).toFixed(0));
    setCommissionRateGroup((appConfig.commissionRateGroup * 100).toFixed(0));
    setCommissionRateChargePoint((appConfig.commissionRateChargePoint * 100).toFixed(0));
    setCommissionGrounds(
      appConfig.commissionRateLandlord
        ? JSON.parse(appConfig.commissionRateLandlord)?.map((item) => {
          return {
            key: item.key,
            name: item.name,
            value: item.value,
          };
        })
        : [{ name: '', value: 0 }]
    );
  }, [appConfig]);

  useEffect(() => {
    if (agencyId) handleGetAgencyDetail(agencyId);
    else setIsReady(true);
  }, [agencyId]);

  const handleGetAgencyDetail = (id) => {
    DealerHelper.callApiGetAgencyDetail(id).then((data) => {
      if (data && Object.keys(data)?.length > 0) {
        if (!isAddSubAgency) {
          setAgencyDetail(data);
          setAdminAgency(!data?.parentAgencyId);
          const hasSaleCommission = data?.commissions?.some(commission => commission?.role === 'SALE') ?? false;
          setHasSaleCommission(hasSaleCommission);

          if (agencyRole !== 'SALE') {
            const commission =
              data?.commissions?.length > 0
                ? data.commissions.find((item) => item?.role === agencyRole)
                : [];
            setCommission(commission);
          }
          const shouldLoadSaleCommission = hasSaleCommission
            || ((agencyRole === 'INVESTOR' || agencyRole === 'COINVESTOR') && (data?.numberOfSignedContracts ?? 0) > 0);

          if (shouldLoadSaleCommission) {
            const salesCommission =
              data?.commissions?.length > 0
                ? data.commissions.find((item) => item?.role === 'SALE' && !item?.stationId)
                : [];
            setSalesCommission(salesCommission);
            const salesEnergyCommission =
              data?.commissions?.length > 0
                ? data.commissions.find((item) => item?.role === 'SALE' && item?.stationId && item?.isInvestorEnergyCommission)
                : [];
            setSalesEnergyCommission(salesEnergyCommission);
            const coinvestorEnergyCommission =
              data?.commissions?.length > 0
                ? data.commissions.find((item) => item?.role === 'SALE' && item?.stationId && !item?.isInvestorEnergyCommission)
                : [];
            setCoinvestorEnergyCommission(coinvestorEnergyCommission);
          }
          if (data?.idCardDocuments) {
            setImageSrc(data.idCardDocuments);
          }
        } else {
          setParentAgencyDetail(data);
        }

        setIsReady(true);
      }
    });
  };

  useEffect(() => {
    if (agencyDetail?.parentAgencyId) {
      DealerHelper.callApiGetAgencyDetail(agencyDetail?.parentAgencyId).then((data) => {
        if (data && Object.keys(data)?.length > 0) {
          setParentAgencyDetail(data);
        }
      });
    }
  }, [agencyDetail]);

  useEffect(() => {
    if (
      salesEnergyCommission?.length ||
      (typeof salesEnergyCommission === 'object' && Object.values(salesEnergyCommission)?.length)
    ) {
      if (salesEnergyCommission?.energyCommissionValue || salesEnergyCommission?.energyCommissionDuration) {
        setIsEnergyCommissionOn(true);
      } else setIsEnergyCommissionOn(false);
    }
  }, [salesEnergyCommission]);

  useEffect(() => {
    if (
      coinvestorEnergyCommission?.length ||
      (typeof coinvestorEnergyCommission === 'object' && Object.values(coinvestorEnergyCommission)?.length)
    ) {
      if (coinvestorEnergyCommission?.energyCommissionValue || coinvestorEnergyCommission?.energyCommissionDuration) {
        setIsEnergyCoinvestorCommissionOn(true);
      } else setIsEnergyCoinvestorCommissionOn(false);
    }
  }, [coinvestorEnergyCommission]);

  const tabs = useMemo(() => {
    if (isAdminAgency) {
      return []
    } else if (agencyRole === 'SALE') {
      return [
        t(`agencyInfo_${agencyRole}`),
        // t('packageCommission'),
        t('Hoa hồng bán nhượng quyền'),
        'Hoa hồng bán liên kết',
        // t('Hoa hồng bán trụ sạc'),
        // t('landlordCommission'),
      ].reverse();
    } else if (agencyRole === 'INVESTOR') {
      if (hasSignedContract) {
        return [
          t(`agencyInfo_${agencyRole}`),
          t('Thông tin đầu tư'),
          t('Hoa hồng bán nhượng quyền'),
          t('Hoa hồng bán liên kết'),
        ].reverse();
      }
      return [
        t(`agencyInfo_${agencyRole}`),
      ].reverse();
    } else if (agencyRole === 'COINVESTOR') {
      if (hasSignedContract) {
        return [
          t(`agencyInfo_${agencyRole}`),
          t('Thông tin đầu tư'),
          t('Hoa hồng bán nhượng quyền'),
          t('Hoa hồng bán liên kết'),
        ].reverse();
      }
      return [
        t(`agencyInfo_${agencyRole}`),
      ].reverse();
    } else if (agencyRole === 'GROUP') {
      if (hasSaleCommission) {
        return [
          t(`agencyInfo_${agencyRole}`),
          t('packageCommission'),
          t('Hoa hồng bán nhượng quyền'),
          t('Hoa hồng bán trụ sạc'),
          t('landlordCommission'),
        ].reverse();
      }
      return [
        t(`agencyInfo_${agencyRole}`),
      ].reverse();
    } else if (agencyRole === 'LANDLORD' || agencyRole === 'CHARGEPOINT' || agencyRole === 'VOUCHER_PARTNER') {
      return [
        t(`agencyInfo_${agencyRole}`),
      ].reverse();
    }
  }, [agencyRole, isAdminAgency, hasSaleCommission, hasSignedContract, t]);

  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    setSelectedTab(newTab);
  };

  useEffect(() => {
    handleSetCommissionUnit(commission?.energyCommissionMode, setCommissionUnit);
  }, [commission]);

  useEffect(() => {
    handleSetCommissionUnit(salesEnergyCommission?.energyCommissionMode, setSalesCommissionUnit);
  }, [salesEnergyCommission]);

  useEffect(() => {
    handleSetCommissionUnit(coinvestorEnergyCommission?.energyCommissionMode, setEnergyCoinvestorCommissionUnit);
  }, [coinvestorEnergyCommission]);

  const classifyOperators = (operators) => {
    if (!operators) return;
    setOperatorList(
      operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
    );
  };

  useEffect(() => {
    if (app.appConfig) {
      classifyOperators(app.appConfig.operators);
    }
  }, [app.appConfig]);

  useEffect(() => {
    handleGetBankList();
  }, []);

  const handleGetBankList = async () => {
    const banks = await miscHelper.callApiGetBankList();
    const bankList = banks?.map((bank) => {
      return { bankCode: bank?.bankCode, shortName: bank?.shortName, bankName: bank?.bankName };
    });
    setBankList(bankList);
  };

  useEffect(() => {
    if (salesCommission) {
      if (!!salesCommission?.landlordCommission?.length && salesCommission?.landlordCommission?.some(item => item !== null)) {
        setIsLandlordCommissionOn(true);
      } else {
        setIsLandlordCommissionOn(false);
      }
    } else {
      setIsLandlordCommissionOn(true);
    }
  }, [salesCommission]);

  useEffect(() => {
    if (!isAddSubAgency) {
      if (user?.agency?.agencyId) {
        agencyList.push({
          name: user?.agency?.name,
          value: user?.agency?.agencyId,
          primaryRole: user?.agency?.primaryRole,
        });
      }
    } else {
      if (parentAgencyDetail?.agencyId) {
        agencyList.push({
          name: parentAgencyDetail?.name,
          value: parentAgencyDetail?.agencyId,
          primaryRole: parentAgencyDetail?.agency?.primaryRole,
        });
      }
    }
  }, [user, isAddSubAgency, parentAgencyDetail]);

  const formatAgenciesData = (agencies) => {
    return agencies.flatMap((agency) => {
      const baseAgency = {
        name: agency?.name || '',
        value: agency?.agencyId || '',
        primaryRole: agency?.primaryRole || '',
      };

      const subAgencies = (agency?.subAgencies || [])?.map((subAgency) => ({
        name: subAgency?.name || '',
        value: subAgency?.agencyId || '',
        primaryRole: agency?.primaryRole || '',
      }));

      return [baseAgency, ...subAgencies];
    });
  };

  useEffect(() => {
    if (agencyRole === 'SALE') fetchAgencyList();
  }, [user, agencyId, agencyRole, adminRole]);

  const fetchAgencyList = async () => {
    try {
      const { result, agencies } = await agencyApi.getAgencyList(
        Utils.filterParams(filterAgencyList)
      );
      if (result === 'success') {
        const formattedAgencies = formatAgenciesData(agencies);
        setAgencyList((prevList) => [...prevList, ...formattedAgencies]);
      }
    } catch (error) {
      console.error('Error fetching agency list:', error);
    }
  };

  const handleClose = () => {
    router.navigate(-1);
  };

  const handleFormatCommission = (commission) => {
    let accumulatedDiscount = 0;

    const formattedCommission = commission?.map((item, index) => {
      if (index === 0) {
        accumulatedDiscount = Number(item.discount);
        return item;
      }

      const currentDiscount = Number(item.discount);
      accumulatedDiscount = accumulatedDiscount + currentDiscount;
      const newDiscount = String(accumulatedDiscount);

      return { ...item, discount: newDiscount };
    });

    return formattedCommission;
  };

  const handleUploadFile = async (idCardType) => {
    const newImagePaths = [];
    for (let index = 0; index < (idCardType === 'CC' ? 2 : 1); index++) {
      const image = imageSrc[index];
      if (image instanceof File) {
        const res = await miscHelper.callApiUploadFile(image);
        newImagePaths.push(res[0].relativePath);
      } else if (!!image) {
        newImagePaths.push(image);
      }
    }
    return newImagePaths;
  };

  const handleSubmit = async () => {
    refFormik.current?.handleSubmit();
    setReadyToValidData(true);
    const errors = await refFormik.current.validateForm();
    console.log('errors: ', errors);
    const values = refFormik.current.values;

    if (Object.keys(errors)?.length === 0) {
      if (!!agencyDetail && (!selectedAreaProvince || !selectedAreaDistrict) && values.country === 'VN') {
        ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t(`agencyInfo_${agencyRole}`)}`);
        return;
      }
      if (isEnergyCommissionOn && !selectedChargeStation) {
        ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng bán nhượng quyền')}`);
        return;
      }
      if (isEnergyCoinvestorCommissionOn && !coinvestorSelectedChargeStation) {
        ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng bán liên kết')}`);
        return;
      }

      if (agencyDetail && values.type === 'ORGANIZATION') {
        const validImages = imageSrc?.filter((img) => img != null);
        if (!validImages?.length) {
          ToastHelper.showError('Vui lòng tải lên đủ số lượng giấy tờ');
          return;
        }
      }

      let imagePath = [];
      if (imageSrc?.length > 0) {
        imagePath = await handleUploadFile(values.idCardType);
      }

      const operatorId = operatorList?.find(
        (operator) => operator.name === values.operator
      )?.operatorId;

      const bankName = values.bankCode
        ? bankList?.find((bank) => bank.bankCode === values.bankCode)?.bankName
        : '';

      if (agencyDetail) {
        const agencyInfoResult = {
          fullname: values.fullname,
          legalRepresentative: values?.legalRepresentative,
          legalPosition: values?.legalPosition,
          email: values?.email,
          phone: values?.phone,
          type: values?.type,
          agencyName: values?.agencyName,
          taxCode: values?.taxCode,
          idCardType: values?.idCardType,
          idCardNumber: values?.idCardNumber,
          idCardDocuments: values?.idCardDocuments,
          country: values?.country ?? 'VN',
          areaId: values?.areaId ?? null,
          address: values?.address,
          operator: values?.operator,
          description: values?.description,
          parentAgencyId: values.parentAgencyId,
          idCardIssueDate: values?.idCardIssueDate,
          idCardPlaceOfIssue: values?.idCardPlaceOfIssue,
          dob: values?.dob,
          gender: values?.gender,
          hsmAgreementUUID: values?.hsmAgreementUUID,
          // hsmPasscode: values?.hsmPasscode,
        };

        const isAgencyInfoChange = !_.isEqual(agencyInfoInitial, agencyInfoResult);

        const bankResult = {
          bankCode: values.bankCode,
          bankAccount: values?.bankAccount,
          bankBeneficiary: values?.bankBeneficiary,
        };

        const isBankChange = !_.isEqual(bankInitial, bankResult);

        const agencyCommissionResult = {
          energyCommissionMode: values.energyCommissionMode,
          energyCommissionValue: values?.energyCommissionValue,
        };

        const isAgencyCommissionChange = !_.isEqual(agencyCommissionInitial, agencyCommissionResult);

        const saleCommissionResult = {
          serviceCommission: values?.serviceCommission,
          saleCommission: values?.saleCommission,
          packageCommission: values?.packageCommission,
          landlordCommission: values?.landlordCommission,
          chargePointCommission: values?.chargePointCommission,
        };

        const isSaleCommissionChange = !_.isEqual(saleCommissionInitial, saleCommissionResult) || landlordCommissionChange;

        const saleEnergyCommissionResult = {
          energySalesCommissionMode: values.energySalesCommissionMode,
          energySalesCommissionValue: values?.energySalesCommissionValue,
          energyCommissionDuration: values?.energyCommissionDuration,
          stationId: selectedChargeStation?.id ?? "",
        };

        const isSaleEnergyCommissionChange = !_.isEqual(saleEnergyCommissionInitial, saleEnergyCommissionResult);

        const coinvestorEnergyCommissionResult = {
          coinvestorEnergyCommissionMode: values.coinvestorEnergyCommissionMode,
          coinvestorEnergyCommissionValue: values?.coinvestorEnergyCommissionValue,
          coinvestorEnergyCommissionDuration: values?.coinvestorEnergyCommissionDuration,
          coinvestorStationId: coinvestorSelectedChargeStation?.id ?? "",
        };

        const isCoinvestorEnergyCommissionChange = !_.isEqual(coinvestorEnergyCommissionInitial, coinvestorEnergyCommissionResult);

        let isCommissionSuccess = true;
        let isAgencyBankSuccess = true;

        if (adminRole) {
          if (commission?.commissionId) {
            if (agencyRole === 'INVESTOR' || agencyRole === 'COINVESTOR') {
              isCommissionSuccess = await DealerHelper.callApiUpdateAgencyCommission(
                commission?.commissionId,
                Utils.transformEmptyStrings({
                  operatorId: operatorId,
                  agencyId: agencyDetail?.agencyId,
                  role: agencyRole,
                  energyCommissionMode: 'FIXED_PER_KWH_PER_VEHICLE_TYPE',
                  energyCommissionValue: DealerHelper.formatCommissionMode(
                    values.energyCommissionMode,
                    values.energyCommissionValue
                  ),
                  energyCommissionDuration: values.energyCommissionDuration,
                  serviceCommission: values.serviceCommission / 100,
                  saleCommission: [],
                  packageCommission: [],
                  landlordCommission: [],
                  chargePointCommission: [],
                  coinvestorCommission: [],
                  energyCommissionForCar: values.energyCommissionForCar,
                  energyCommissionForBike: values.energyCommissionForBike,
                  overchargeCommissionValue: values.overchargeCommissionValue,
                })
              );
            } else if (isAgencyCommissionChange) {
              isCommissionSuccess = await DealerHelper.callApiUpdateAgencyCommission(
                commission?.commissionId,
                Utils.transformEmptyStrings({
                  operatorId: operatorId,
                  agencyId: agencyDetail?.agencyId,
                  role: agencyRole,
                  energyCommissionMode: values.energyCommissionMode,
                  energyCommissionValue: DealerHelper.formatCommissionMode(
                    values.energyCommissionMode,
                    values.energyCommissionValue
                  ),
                  energyCommissionDuration: values.energyCommissionDuration,
                  serviceCommission: values.serviceCommission / 100,
                  saleCommission: [],
                  packageCommission: [],
                  landlordCommission: [],
                  chargePointCommission: [],
                  coinvestorCommission: [],
                })
              );
            }
          }

          if (showSaleCommissionSections && salesCommission?.commissionId && isSaleCommissionChange) {
            isCommissionSuccess = await DealerHelper.callApiUpdateAgencyCommission(
              salesCommission?.commissionId,
              Utils.transformEmptyStrings({
                operatorId: operatorId,
                agencyId: agencyDetail?.agencyId,
                role: 'SALE',
                energyCommissionMode: commissionModeList[0],
                energyCommissionValue: 0,
                stationId: null,
                energyCommissionDuration: 0,
                serviceCommission: values.serviceCommission / 100,
                saleCommission: handleFormatCommission(values.saleCommission)?.map((sale) => ({
                  revenue: Number(sale.revenue),
                  discount: Number(sale.discount) / 100,
                })),
                packageCommission: handleFormatCommission(values.packageCommission)?.map((sale) => ({
                  revenue: Number(sale.revenue),
                  discount: Number(sale.discount) / 100,
                })),
                chargePointCommission: handleFormatCommission(values.chargePointCommission)?.map((sale) => ({
                  revenue: Number(sale.revenue),
                  discount: Number(sale.discount) / 100,
                })),
                landlordCommission: isLandlordCommissionOn ? values.landlordCommission : [],
                coinvestorCommission: handleFormatCommission(values.coinvestorCommission)?.map((sale) => ({
                  revenue: Number(sale.revenue),
                  discount: Number(sale.discount) / 100,
                })),
              })
            );
          }

          if (isSaleEnergyCommissionChange) {
            if (salesEnergyCommission?.commissionId) {
              if (isEnergyCommissionOn) {
                isCommissionSuccess = await DealerHelper.callApiUpdateAgencyCommission(
                  salesEnergyCommission?.commissionId,
                  Utils.transformEmptyStrings({
                    operatorId: operatorId,
                    agencyId: agencyDetail?.agencyId,
                    role: 'SALE',
                    energyCommissionMode: values.energySalesCommissionMode,
                    energyCommissionValue: DealerHelper.formatCommissionMode(
                      values.energySalesCommissionMode,
                      values.energySalesCommissionValue
                    ),
                    stationId: selectedChargeStation?.id,
                    energyCommissionDuration: values.energyCommissionDuration,
                    serviceCommission: 0,
                    saleCommission: [],
                    packageCommission: [],
                    landlordCommission: [],
                    isInvestorEnergyCommission: 1,
                  })
                );
              } else {
                isCommissionSuccess = await DealerHelper.callApiDeleteAgencyCommission(
                  salesEnergyCommission?.commissionId
                );
              }
            } else {
              isCommissionSuccess = await DealerHelper.callApiCreateAgencyCommission(
                Utils.transformEmptyStrings({
                  operatorId: operatorId,
                  agencyId: agencyDetail?.agencyId,
                  role: 'SALE',
                  energyCommissionMode: values.energySalesCommissionMode,
                  energyCommissionValue: DealerHelper.formatCommissionMode(
                    values.energySalesCommissionMode,
                    values.energySalesCommissionValue
                  ),
                  stationId: selectedChargeStation?.id,
                  energyCommissionDuration: values.energyCommissionDuration,
                  serviceCommission: 0,
                  saleCommission: [],
                  packageCommission: [],
                  landlordCommission: [],
                  isInvestorEnergyCommission: 1,
                })
              );
            }
          }

          if (isCoinvestorEnergyCommissionChange) {
            if (coinvestorEnergyCommission?.commissionId) {
              if (isEnergyCoinvestorCommissionOn) {
                isCommissionSuccess = await DealerHelper.callApiUpdateAgencyCommission(
                  coinvestorEnergyCommission?.commissionId,
                  Utils.transformEmptyStrings({
                    operatorId: operatorId,
                    agencyId: agencyDetail?.agencyId,
                    role: 'SALE',
                    energyCommissionMode: values.coinvestorEnergyCommissionMode,
                    energyCommissionValue: DealerHelper.formatCommissionMode(
                      values.coinvestorEnergyCommissionMode,
                      values.coinvestorEnergyCommissionValue
                    ),
                    stationId: coinvestorSelectedChargeStation?.id,
                    energyCommissionDuration: values.coinvestorEnergyCommissionDuration,
                    serviceCommission: 0,
                    saleCommission: [],
                    packageCommission: [],
                    landlordCommission: [],
                    isInvestorEnergyCommission: 0,
                  })
                );
              } else {
                isCommissionSuccess = await DealerHelper.callApiDeleteAgencyCommission(
                  coinvestorEnergyCommission?.commissionId
                );
              }
            } else {
              isCommissionSuccess = await DealerHelper.callApiCreateAgencyCommission(
                Utils.transformEmptyStrings({
                  operatorId: operatorId,
                  agencyId: agencyDetail?.agencyId,
                  role: 'SALE',
                  energyCommissionMode: values.coinvestorEnergyCommissionMode,
                  energyCommissionValue: DealerHelper.formatCommissionMode(
                    values.coinvestorEnergyCommissionMode,
                    values.coinvestorEnergyCommissionValue
                  ),
                  stationId: coinvestorSelectedChargeStation?.id,
                  energyCommissionDuration: values.coinvestorEnergyCommissionDuration,
                  serviceCommission: 0,
                  saleCommission: [],
                  packageCommission: [],
                  landlordCommission: [],
                  isInvestorEnergyCommission: 0,
                })
              );
            }
          }
        }

        if (isBankChange) {
          if (values?.bankCode || values?.bankAccount || values?.bankBeneficiary) {
            if (agencyBank?.bankAccountId) {
              isAgencyBankSuccess = await agencyBankHelper.callApiUpdateAgencyBank(
                agencyBank?.bankAccountId,
                Utils.transformEmptyStrings({
                  bankName: bankName,
                  bankCode: values.bankCode,
                  bankAccount: values.bankAccount,
                  bankBeneficiary: values.bankBeneficiary,
                })
              );
            } else {
              isAgencyBankSuccess = await agencyBankHelper.callApiCreateAgencyBank(
                Utils.transformEmptyStrings({
                  bankName: bankName,
                  bankCode: values.bankCode,
                  bankAccount: values.bankAccount,
                  bankBeneficiary: values.bankBeneficiary,
                  defaultAccount: 1,
                  agencyId: agencyDetail?.agencyId,
                })
              );
            }
          } else {
            if (agencyBank?.bankAccountId) {
              isAgencyBankSuccess = await agencyBankHelper.callApiDeleteAgencyBank(
                agencyBank?.bankAccountId
              );
            }
          }
        }

        const userInfoResult = {
          fullname: values.fullname,
          phone: values?.phone,
        };

        const isUserInfoChange = !_.isEqual(userInfoInitial, userInfoResult);

        let isUpdateUserSuccess = true;
        if (mainUser && isUserInfoChange) {
          isUpdateUserSuccess = await AccountHelper.callApiUpdateUser(mainUser?.userId, {
            fullname: values?.fullname,
            phone: values?.phone,
          });
          if (isUpdateUserSuccess) {
            AccountHelper.callApiGetProfile();
          }
        }

        if (isCommissionSuccess && isAgencyBankSuccess && isUpdateUserSuccess) {
          await handleUpdateAgency(isAgencyInfoChange, {
            name: values.agencyName,
            legalRepresentative: values.legalRepresentative,
            legalPosition: values.legalPosition,
            fullname: values.fullname,
            operatorId: operatorId,
            description: values.description,
            phone: values.phone,
            address: values.address,
            taxCode: values.taxCode,
            email: values.email,
            type: values.type,
            country: values?.country ?? 'VN',
            areaId: values.areaId,
            idCardType: values.idCardType,
            idCardNumber: values.idCardNumber,
            idCardDocuments: imagePath,
            idCardPlaceOfIssue: values.idCardPlaceOfIssue,
            idCardIssueDate: values.idCardIssueDate,
            dob: values.dob,
            gender: values.gender,
            hsmAgreementUUID: values?.hsmAgreementUUID,
            // hsmPasscode: values?.hsmPasscode,
          });
        }
      } else {
        const res = await DealerHelper.callApiCreateAgency(
          Utils.transformEmptyStrings({
            parentAgencyId: values.parentAgencyId.agencyId,
            name: values.agencyName,
            legalRepresentative: values.legalRepresentative,
            legalPosition: values.legalPosition,
            fullname: values.fullname,
            operatorId: operatorId,
            description: values.description,
            phone: values.phone,
            address: values.address,
            taxCode: values.taxCode,
            email: values.email,
            type: values.type,
            country: values?.country ?? 'VN',
            areaId: values.areaId,
            idCardType: values.idCardType,
            idCardNumber: values.idCardNumber,
            idCardDocuments: imagePath,
            status: 'NORMAL',
            requestedCommissionModes: [agencyRole],
            idCardPlaceOfIssue: values.idCardPlaceOfIssue,
            primaryRole: agencyRole,
            idCardIssueDate: values.idCardIssueDate,
            dob: values.dob,
            gender: values.gender,
            hsmAgreementUUID: values?.hsmAgreementUUID,
            // hsmPasscode: values?.hsmPasscode,
            saleKPI: defaultSaleKPI,
            packageKPI: defaultPackageKPI,
          })
        );

        if (res) {
          let isSuccessBank = true,
            isSuccessCommission = true,
            isSuccessEnergyCommission = true,
            isSuccessCoinvestorEnergyCommission = true;
          if (values?.bankCode || values?.bankAccount || values?.bankBeneficiary) {
            isSuccessBank = await agencyBankHelper.callApiCreateAgencyBank(
              Utils.transformEmptyStrings({
                bankName: bankName,
                bankCode: values.bankCode,
                bankAccount: values.bankAccount,
                bankBeneficiary: values.bankBeneficiary,
                defaultAccount: 1,
                agencyId: res.agency?.agencyId,
              })
            );
          } else {
            isSuccessBank = true;
          }

          if (adminRole) {
            const agencyCommissionResult = {
              energyCommissionMode: values.energyCommissionMode,
              energyCommissionValue: values?.energyCommissionValue,
            };

            const saleCommissionResult = {
              serviceCommission: values.serviceCommission,
              saleCommission: values?.saleCommission,
              packageCommission: values?.packageCommission,
              chargePointCommission: values?.chargePointCommission,
              landlordCommission: values?.landlordCommission,
              coinvestorCommission: values?.coinvestorCommission,
            };

            const isAgencyCommissionChange = !_.isEqual(agencyCommissionInitial, agencyCommissionResult);
            const isSaleCommissionChange = !_.isEqual(saleCommissionInitial, saleCommissionResult);

            DealerHelper.callApiGetAgencyDetail(res.agency.agencyId).then(async (data) => {
              if (data?.commissions[0]?.commissionId) {
                if (agencyRole === 'INVESTOR' || agencyRole === 'COINVESTOR') {
                  isSuccessCommission = await DealerHelper.callApiUpdateAgencyCommission(
                    data?.commissions[0]?.commissionId,
                    Utils.transformEmptyStrings({
                      operatorId: operatorId,
                      agencyId: res.agency?.agencyId,
                      role: agencyRole,
                      energyCommissionMode: 'FIXED_PER_KWH_PER_VEHICLE_TYPE',
                      energyCommissionValue: 0,
                      energyCommissionDuration: 0,
                      stationId: null,
                      serviceCommission: values.serviceCommission / 100,
                      saleCommission: [],
                      packageCommission: [],
                      chargePointCommission: [],
                      landlordCommission: [],
                      energyCommissionForCar: values.energyCommissionForCar,
                      energyCommissionForBike: values.energyCommissionForBike,
                      overchargeCommissionValue: values.overchargeCommissionValue,
                    })
                  );
                } else if (isAgencyCommissionChange || isSaleCommissionChange) {
                  isSuccessCommission = await DealerHelper.callApiUpdateAgencyCommission(
                    data?.commissions[0]?.commissionId,
                    Utils.transformEmptyStrings({
                      operatorId: operatorId,
                      agencyId: res.agency?.agencyId,
                      role: agencyRole,
                      energyCommissionMode: commissionModeList[0],
                      energyCommissionValue: 0,
                      energyCommissionDuration: 0,
                      stationId: null,
                      serviceCommission: values.serviceCommission / 100,
                      saleCommission: agencyRole === 'SALE'
                        ? handleFormatCommission(values.saleCommission)?.map((sale) => ({
                          revenue: Number(sale.revenue),
                          discount: Number(sale.discount) / 100,
                        }))
                        : [],
                      packageCommission: agencyRole === 'SALE'
                        ? handleFormatCommission(values.packageCommission)?.map((sale) => ({
                          revenue: Number(sale.revenue),
                          discount: Number(sale.discount) / 100,
                        }))
                        : [],
                      chargePointCommission: agencyRole === 'SALE'
                        ? handleFormatCommission(values.chargePointCommission)?.map((sale) => ({
                          revenue: Number(sale.revenue),
                          discount: Number(sale.discount) / 100,
                        }))
                        : [],
                      landlordCommission: agencyRole === 'SALE' && isLandlordCommissionOn ? values.landlordCommission : [],
                      coinvestorCommission: agencyRole === 'SALE'
                        ? handleFormatCommission(values.coinvestorCommission)?.map((sale) => ({
                          revenue: Number(sale.revenue),
                          discount: Number(sale.discount) / 100,
                        }))
                        : [],
                    })
                  );
                }
              } else {
                isSuccessCommission = true;
              }

              if (isEnergyCommissionOn) {
                isSuccessEnergyCommission = await DealerHelper.callApiCreateAgencyCommission(
                  Utils.transformEmptyStrings({
                    operatorId: operatorId,
                    agencyId: res.agency?.agencyId,
                    role: 'SALE',
                    energyCommissionMode: values.energyCommissionMode,
                    energyCommissionValue: DealerHelper.formatCommissionMode(
                      values.energyCommissionMode,
                      values.energyCommissionValue
                    ),
                    energyCommissionDuration: values.energyCommissionDuration,
                    stationId: selectedChargeStation?.id,
                    serviceCommission: 0,
                    saleCommission: [],
                    packageCommission: [],
                    landlordCommission: [],
                    isInvestorEnergyCommission: 1,
                  })
                );
              } else {
                isSuccessEnergyCommission = true;
              }

              if (isEnergyCoinvestorCommissionOn) {
                isSuccessCoinvestorEnergyCommission = await DealerHelper.callApiCreateAgencyCommission(
                  Utils.transformEmptyStrings({
                    operatorId: operatorId,
                    agencyId: res.agency?.agencyId,
                    role: 'SALE',
                    energyCommissionMode: values.coinvestorEnergyCommissionMode,
                    energyCommissionValue: DealerHelper.formatCommissionMode(
                      values.coinvestorEnergyCommissionMode,
                      values.coinvestorEnergyCommissionValue
                    ),
                    energyCommissionDuration: values.coinvestorEnergyCommissionDuration,
                    stationId: coinvestorSelectedChargeStation?.id,
                    serviceCommission: 0,
                    saleCommission: [],
                    packageCommission: [],
                    landlordCommission: [],
                    isInvestorEnergyCommission: 0,
                  })
                );
              } else {
                isSuccessCoinvestorEnergyCommission = true;
              }

              if (isSuccessBank && isSuccessCommission && isSuccessEnergyCommission && isSuccessCoinvestorEnergyCommission) {
                ToastHelper.showSuccess(`Tạo ${t(`abbAgencyRole_${agencyRole}`)} thành công`);
                handleClose();
              } else {
                ToastHelper.showError(`Tạo ${t(`abbAgencyRole_${agencyRole}`)} thất bại`);
              }
            });
          } else {
            if (res.result === 'success') {
              ToastHelper.showSuccess(`Tạo ${t(`abbAgencyRole_${agencyRole}`)} thành công`);
              handleClose();
            } else {
              ToastHelper.showError(`Tạo ${t(`abbAgencyRole_${agencyRole}`)} thất bại`);
            }
          }
        }
      }
    } else {
      if (
        selectedTab === t('Hoa hồng bán nhượng quyền') ||
        selectedTab === t('packageCommission') ||
        selectedTab === t('landlordCommission') ||
        selectedTab === t('Hoa hồng đầu tư NQ') ||
        selectedTab === t('Hoa hồng bán trụ sạc') ||
        selectedTab === t('Thông tin đầu tư') ||
        selectedTab === t('Hoa hồng bán liên kết')
      ) {
        if (
          errors.fullname ||
          errors.idCardNumber ||
          errors.taxCode ||
          errors.email ||
          errors.phone ||
          errors.city ||
          errors.district ||
          errors.areaId ||
          errors.address ||
          errors.bankCode ||
          errors.bankAccount ||
          errors.bankBeneficiary
        ) {
          ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t(`agencyInfo_${agencyRole}`)}`);
        }
      }
      if (
        (showSaleCommissionSections || isEnergyCommissionOn) && (
          selectedTab === t(`agencyInfo_${agencyRole}`) ||
          selectedTab === t('packageCommission') ||
          selectedTab === t('landlordCommission') ||
          selectedTab === t('Hoa hồng đầu tư NQ') ||
          selectedTab === t('Hoa hồng bán trụ sạc') ||
          selectedTab === t('Thông tin đầu tư') ||
          selectedTab === t('Hoa hồng bán liên kết')
        )
      ) {
        if (
          errors.saleCommission ||
          isEnergyCommissionOn && (
            !values.energySalesCommissionMode ||
            !values.energySalesCommissionValue ||
            !values.energyCommissionDuration
          )
        ) {
          ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng bán nhượng quyền')}`);
        }
      }
      if (
        showSaleCommissionSections && (
          selectedTab === t('Hoa hồng bán nhượng quyền') ||
          selectedTab === t(`agencyInfo_${agencyRole}`) ||
          selectedTab === t('landlordCommission') ||
          selectedTab === t('Hoa hồng đầu tư NQ') ||
          selectedTab === t('Hoa hồng bán trụ sạc') ||
          selectedTab === t('Thông tin đầu tư') ||
          selectedTab === t('Hoa hồng bán liên kết')
        )
      ) {
        if (errors.packageCommission) {
          ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('packageCommission')}`);
        }
      }
      if (
        (agencyRole === 'INVESTOR' || agencyRole === 'COINVESTOR') && (
          selectedTab === t('Hoa hồng bán nhượng quyền') ||
          selectedTab === t(`agencyInfo_${agencyRole}`) ||
          selectedTab === t('landlordCommission') ||
          selectedTab === t('packageCommission')
        )
      ) {
        if (
          errors.energyCommissionMode ||
          errors.energyCommissionValue
        ) {
          ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng đầu tư NQ')}`);
        }
      }
      if (
        agencyRole === 'SALE' && (
          selectedTab === t('Hoa hồng bán nhượng quyền') ||
          selectedTab === t(`agencyInfo_${agencyRole}`) ||
          selectedTab === t('landlordCommission') ||
          selectedTab === t('packageCommission') ||
          selectedTab === t('Thông tin đầu tư') ||
          selectedTab === t('Hoa hồng bán liên kết')
        )
      ) {
        if (errors.chargePointCommission) {
          ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng bán trụ sạc')}`);
        }
      }
      if (
        (showSaleCommissionSections || isEnergyCommissionOn) && (
          selectedTab === t(`agencyInfo_${agencyRole}`) ||
          selectedTab === t('packageCommission') ||
          selectedTab === t('landlordCommission') ||
          selectedTab === t('Hoa hồng đầu tư NQ') ||
          selectedTab === t('Hoa hồng bán trụ sạc') ||
          selectedTab === t('Thông tin đầu tư') ||
          selectedTab === t('Hoa hồng bán nhượng quyền')
        )
      ) {
        if (
          errors.coinvestorCommission ||
          errors.coinvestorEnergyCommissionValue ||
          errors.coinvestorEnergyCommissionDuration ||
          isEnergyCoinvestorCommissionOn && (
            !values.coinvestorEnergyCommissionMode ||
            !values.coinvestorEnergyCommissionValue ||
            !values.coinvestorEnergyCommissionDuration
          )
        ) {
          ToastHelper.showError(`${t('pleaseFillAllInfo')} ${t('Hoa hồng bán liên kết')}`);
        }
      }
    }
  };

  const handleUpdateAgency = async (isAgencyInfoChange, params) => {
    if (isAgencyInfoChange || uploadFile) {
      const isSuccess = await DealerHelper.callApiUpdateAgency(
        agencyDetail.agencyId,
        Utils.transformEmptyStrings(params)
      );
      if (isSuccess) {
        ToastHelper.showSuccess(`Cập nhật thông tin ${t(`abbAgencyRole_${agencyRole}`)} thành công`);
        handleClose();
      } else {
        ToastHelper.showError(`Cập nhật thông tin ${t(`abbAgencyRole_${agencyRole}`)} thất bại`);
      }
    } else {
      ToastHelper.showSuccess(`Cập nhật thông tin ${t(`abbAgencyRole_${agencyRole}`)} thành công`);
      handleClose();
    }
  };

  const handleSetImage = (file, index) => {
    setImageSrc((prev) => {
      const updatedImageSrc = [...prev];
      updatedImageSrc[index] = file;
      return updatedImageSrc;
    });
    setUploadFile(true);
  };

  const handleSetCommissionUnit = (value, setCommissionUnit) => {
    const unit = DealerHelper.checkPercentCommissionMode(value) ? '%' : 'VNĐ/kWh';
    setCommissionUnit(unit);
  };

  const handleCreateSubAgencySuccess = () => {
    AppDialogHelper.show(
      agencyRole === 'SALE' ? t('Tạo đại lý thành công') : t('Tạo nhà đầu tư thành công'),
      agencyRole === 'SALE'
        ? t('Tạo đại lý thành công, vui lòng kiểm tra hòm thư của đại lý để kích hoạt tài khoản')
        : t(
          'Tạo nhà đầu tư thành công, vui lòng kiểm tra hòm thư của nhà đầu tư để kích hoạt tài khoản'
        ),
      [
        {
          title: t('Đóng'),
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogSuccess
    );
  };

  const handleToggleSale = () => {
    setIsEnergyCommissionOn((prev) => {
      const newState = !prev;
      if (!newState) {
        refFormik.current?.setFieldValue('energySalesCommissionValue', '');
        refFormik.current?.setFieldValue('energyCommissionDuration', '');
        setSelectedChargeStation(null);
      }
      refFormik.current?.setFieldValue('isEnergyCommissionOn', newState);
      return newState;
    });
  };

  const handleToggleCoinvestor = () => {
    setIsEnergyCoinvestorCommissionOn((prev) => {
      const newState = !prev;
      if (!newState) {
        refFormik.current?.setFieldValue('coinvestorEnergyCommissionValue', '');
        refFormik.current?.setFieldValue('coinvestorEnergyCommissionDuration', '');
        setCoinvestorSelectedChargeStation(null);
      }
      refFormik.current?.setFieldValue('isEnergyCoinvestorCommissionOn', newState);
      return newState;
    });
  };

  const handleToggleLandlord = () => {
    setIsLandlordCommissionOn((prev) => !prev);
    setLandlordCommissionChange(true);
  };

  const commissionModeList = [
    AppConstants.energyCommissionMode.fixedPerKwh,
    AppConstants.energyCommissionMode.percentInput,
    AppConstants.energyCommissionMode.percentOutput,
    AppConstants.energyCommissionMode.percentProfit,
  ];

  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  const [isAffiliateEnergyCommissionOn, setIsAffiliateEnergyCommissionOn] = useState(false);
  const [affiliateCommissionUnit, setAffiliateCommissionUnit] = useState('');
  const [selectedAffiliateChargeStation, setSelectedAffiliateChargeStation] = useState(null);

  const handleToggleAffiliate = () => {
    setIsAffiliateEnergyCommissionOn((prev) => {
      const next = !prev;
      if (!next) {
        refFormik.current?.setFieldValue('affiliateEnergyCommissionValue', '');
        refFormik.current?.setFieldValue('affiliateEnergyCommissionDuration', '');
        setSelectedAffiliateChargeStation(null);
      }
      return next;
    });
  };

  useEffect(() => {
    if (salesEnergyCommission?.stationId) {
      ChargeHelper.API.getChargeStationDetail(salesEnergyCommission?.stationId).then((station) => {
        setSelectedChargeStation({
          id: station?.stationId,
          stationCode: station?.stationCode,
          name: station?.name,
          item: station,
          address: ChargeHelper.Utils.getChargeStationFullAddress(station),
        });
      });
    }
  }, [salesEnergyCommission])
  const [coinvestorSelectedChargeStation, setCoinvestorSelectedChargeStation] = useState(null);
  useEffect(() => {
    if (coinvestorEnergyCommission?.stationId) {
      ChargeHelper.API.getChargeStationDetail(coinvestorEnergyCommission?.stationId).then((station) => {
        setCoinvestorSelectedChargeStation({
          id: station?.stationId,
          stationCode: station?.stationCode,
          name: station?.name,
          item: station,
          address: ChargeHelper.Utils.getChargeStationFullAddress(station),
        });
      });
    }
  }, [coinvestorEnergyCommission])

  const validationSchema = Yup.object().shape({
    agencyName: Yup.string()
      .required(t('agencyNameRequired'))
      .test('len', t('invalid', { field: 'agencyName' }), (val) => {
        if (val) {
          return val.trim().length;
        }
      }),
    fullname: Yup.string()
      .when('type', {
        is: (type) => type === 'INDIVIDUAL',
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      })
      .test('len', t('invalid', { field: 'fullname' }), (val) => {
        if (val) {
          return val.trim().length;
        }
        return true;
      }),
    idCardNumber: Yup.string()
      .when(['type', 'idCardType'], {
        is: (type) => type !== 'ORGANIZATION',
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      })
      .test('len', t('invalid', { field: 'idCardNumber' }), (val, context) => {
        const { idCardType } = context.parent;
        if (val) {
          return (
            !val.toString().includes(' ') &&
            (idCardType === 'CC'
              ? val.toString().match(AppConfigs.regex.idCardNumber)
              : val.toString().match(AppConfigs.regex.passportNumber))
          );
        }
        return true;
      }),
    email: Yup.string().required(t('emailRequired'))
      .test('len', t('Email không hợp lệ', { field: 'email' }), (val) => {
        if (val) {
          return (
            !val.toString().includes(' ') &&
            val.toString().match(AppConfigs.regex.email)
          )
        }
        return false;
      }),
    phone: Yup.string()
      .required(t('phoneRequired'))
      .test('len', t('invalid', { field: 'phone' }), (val) => {
        if (val) {
          return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
        }
      }),
    type: Yup.string().required(t('required')),
    taxCode: Yup.string()
      .when(['type', 'isEdit'], {
        is: (type, isEdit) => type === 'ORGANIZATION' && isEdit,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      })
      .test('len', t('invalid', { field: 'taxCode' }), (val) => {
        if (val) {
          return (
            !val.toString().includes(' ') &&
            (val.toString().match(AppConfigs.regex.taxCode10) ||
              val.toString().match(AppConfigs.regex.taxCode13))
          );
        }
        return true;
      }),
    bankCode: Yup.string()
      .when(['isEdit', 'isAdminAgency', 'isVoucherPartner'], {
        is: (isEdit, isAdminAgency, isVoucherPartner) => !isAdminAgency && isEdit && !isVoucherPartner,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      })
      .test(
        'bankCode-required-if-bankAccount-bankBeneficiary',
        t('required'),
        function (value) {
          const bankAccount = this.parent.bankAccount;
          const bankBeneficiary = this.parent.bankBeneficiary;
          if (bankAccount && bankAccount.trim().length > 0 || bankBeneficiary && bankBeneficiary.trim().length > 0) {
            return value && value.trim().length > 0;
          }
          return true;
        }
      ),
    bankAccount: Yup.string()
      .when(['isEdit', 'isAdminAgency', 'isVoucherPartner'], {
        is: (isEdit, isAdminAgency, isVoucherPartner) => !isAdminAgency && isEdit && !isVoucherPartner,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      })
      .test('bankAccount-required-if-bankCode-bankBeneficiary',
        t('required'),
        function (value) {
          const bankCode = this.parent.bankCode;
          const bankBeneficiary = this.parent.bankBeneficiary;
          if (bankCode && bankCode.trim().length > 0 || bankBeneficiary && bankBeneficiary.trim().length > 0) {
            return value && value.trim().length > 0;
          }
          return true;
        }),
    bankBeneficiary: Yup.string()
      .when(['isEdit', 'isAdminAgency', 'isVoucherPartner'], {
        is: (isEdit, isAdminAgency, isVoucherPartner) => !isAdminAgency && isEdit && !isVoucherPartner,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      })
      .test('bankAccount-required-if-bankCode-bankAccount',
        t('required'),
        function (value) {
          const bankAccount = this.parent.bankAccount;
          const bankCode = this.parent.bankCode;
          if (bankAccount && bankAccount.trim().length > 0 || bankCode && bankCode.trim().length > 0) {
            return value && value.trim().length > 0;
          }
          return true;
        }),
    country: Yup.string()
      .when('isEdit', {
        is: true,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    areaId: Yup.string()
      .when(['isEdit', 'country'], {
        is: (isEdit, country) => isEdit && country === 'VN',
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    address: Yup.string()
      .when('isEdit', {
        is: true,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    dob: Yup.string()
      .when(['type', 'isEdit'], {
        is: (type, isEdit) => type !== 'ORGANIZATION' && isEdit,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    gender: Yup.string()
      .when('isEdit', {
        is: true,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    legalRepresentative: Yup.string()
      .when(['type', 'isEdit'], {
        is: (type, isEdit) => type === 'ORGANIZATION' && isEdit,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    legalPosition: Yup.string()
      .when(['type', 'isEdit'], {
        is: (type, isEdit) => type === 'ORGANIZATION' && isEdit,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema.notRequired(),
      }),
    energyCommissionValue: Yup.number()
      .min(0, t('invalid'))
      .test('len', t('invalid', { field: 'energyCommissionValue' }), (val) => {
        if (val !== undefined && val !== null) {
          if (commissionUnit === '%') {
            return val <= 100;
          }
          return true;
        }
        return true;
      }),
    energySalesCommissionValue: Yup.number()
      .when('isAdminAgency', {
        is: true,
        then: (schema) => schema.notRequired().nullable(),
        otherwise: (schema) =>
          schema
            .test(
              'energySalesCommissionValue',
              t('invalid', { field: 'energySalesCommissionValue' }),
              (val, ctx) => {
                if (!isEnergyCommissionOn) return true;
                if (val === undefined || val === null) return false;

                const unit = ctx.parent.salesCommissionUnit || salesCommissionUnit;

                if (unit === '%') {
                  return val <= 100;
                }
                return val > 0;
              }
            ),
      }),
    energyCommissionDuration: Yup.number()
      .test(
        'energyCommissionDuration',
        t('invalid', { field: 'energyCommissionDuration' }),
        (val, ctx) => {
          if (!isEnergyCommissionOn) return true;
          if (val === undefined || val === null) return false;
          return val > 0;
        }
      ),
    coinvestorEnergyCommissionValue: Yup.number()
      .when('isAdminAgency', {
        is: true,
        then: (schema) => schema.notRequired().nullable(),
        otherwise: (schema) =>
          schema
            .test(
              'coinvestorEnergyCommissionValue',
              t('invalid', { field: 'coinvestorEnergyCommissionValue' }),
              (val, ctx) => {
                if (!isEnergyCoinvestorCommissionOn) return true;
                if (val === undefined || val === null) return false;

                const unit = ctx.parent.energyCoinvestorCommissionUnit || energyCoinvestorCommissionUnit;

                if (unit === '%') {
                  return val <= 100;
                }
                return val > 0;
              }
            ),
      }),
    coinvestorEnergyCommissionDuration: Yup.number()
      .test(
        'coinvestorEnergyCommissionDuration',
        t('invalid', { field: 'coinvestorEnergyCommissionDuration' }),
        (val, ctx) => {
          if (!isEnergyCoinvestorCommissionOn) return true;
          if (val === undefined || val === null) return false;
          return val > 0;
        }
      ),
    saleCommission: Yup.array().when('adminRole', {
      is: true,
      then: Yup.array()
        .of(
          Yup.object().shape({
            discount: Yup.number().min(0, t('invalid')).max(100, t('invalid')),
            revenue: Yup.number()
              .min(0, t('invalid'))
              .test('len', t('invalid'), function (value) {
                const { options, parent } = this;
                const saleCommission = options.context?.saleCommission ?? [];
                const index = options.index;
                if (index > 0 && !value) return false;
                if (index === 0 || !saleCommission[index - 1]) return true;
                if (value <= (saleCommission[index - 1]?.revenue ?? 0)) {
                  return false;
                }
                return true;
              }),
          })
        )
        .min(1, t('invalid')),
      otherwise: Yup.array(),
    }),
    coinvestorCommission: Yup.array().when('adminRole', {
      is: true,
      then: Yup.array()
        .of(
          Yup.object().shape({
            discount: Yup.number().min(0, t('invalid')).max(100, t('invalid')),
            revenue: Yup.number()
              .min(0, t('invalid'))
              .test('len', t('invalid'), function (value) {
                const { options, parent } = this;
                const coinvestorCommission = options.context?.coinvestorCommission ?? [];
                const index = options.index;
                if (index > 0 && !value) return false;
                if (index === 0 || !coinvestorCommission[index - 1]) return true;
                if (value <= (coinvestorCommission[index - 1]?.revenue ?? 0)) {
                  return false;
                }
                return true;
              }),
          })
        )
        .min(1, t('invalid')),
      otherwise: Yup.array(),
    }),
    packageCommission: Yup.array().when('adminRole', {
      is: true,
      then: Yup.array()
        .of(
          Yup.object().shape({
            discount: Yup.number().min(0, t('invalid')).max(100, t('invalid')),
            revenue: Yup.number()
              .min(0, t('invalid'))
              .test('len', t('invalid'), function (value) {
                const { options, parent } = this;
                const packageCommission = options.context?.packageCommission ?? [];
                const index = options.index;
                if (index === 0 || !packageCommission[index - 1]) return true;
                if (value <= (packageCommission[index - 1]?.revenue ?? 0)) {
                  return false;
                }
                return true;
              }),
          })
        )
        .min(1, t('invalid')),
      otherwise: Yup.array(),
    }),
    chargePointCommission: Yup.array().when('adminRole', {
      is: true,
      then: Yup.array()
        .of(
          Yup.object().shape({
            discount: Yup.number().min(0, t('invalid')).max(100, t('invalid')),
            revenue: Yup.number()
              .min(0, t('invalid'))
              .test('len', t('invalid'), function (value) {
                const { options, parent } = this;
                const chargePointCommission = options.context?.chargePointCommission ?? [];
                const index = options.index;
                if (index === 0 || !chargePointCommission[index - 1]) return true;
                if (value <= (chargePointCommission[index - 1]?.revenue ?? 0)) {
                  return false;
                }
                return true;
              }),
          })
        )
        .min(1, t('invalid')),
      otherwise: Yup.array(),
    }),
    idCardType: Yup.string()
      .when('isEdit', {
        is: true,
        then: (schema) => schema.required('Vui lòng chọn loại giấy tờ'),
        otherwise: (schema) => schema.nullable(),
      }),
    idCardType: Yup.string().required(),
    adminRole: Yup.boolean(),
    isEdit: Yup.boolean(),
    isAdminAgency: Yup.boolean(),
    isEnergyCommissionOn: Yup.boolean(),
    isEnergyCoinvestorCommissionOn: Yup.boolean(),
    isVoucherPartner: Yup.boolean(),
  });

  const userInfoInitial = {
    fullname: agencyDetail?.name ?? '',
    phone: agencyDetail?.phone ?? '',
  }

  const agencyInfoInitial = {
    fullname: agencyDetail?.name ?? '',
    legalRepresentative: agencyDetail?.legalRepresentative ?? '',
    legalPosition: agencyDetail?.legalPosition ?? '',
    email: agencyDetail?.email ?? '',
    phone: agencyDetail?.phone ?? '',
    type: agencyDetail?.type ?? AppConstants.accountType.individual,
    agencyName: agencyDetail?.name ?? '',
    taxCode: agencyDetail?.taxCode ?? '',
    idCardType: agencyDetail?.idCardType ?? 'CC',
    idCardNumber: agencyDetail?.idCardNumber ?? '',
    idCardDocuments:
      agencyDetail?.ekycVerified === 1
        ? agencyDetail?.idCardDocuments?.slice(1) ?? []
        : agencyDetail?.idCardDocuments ?? [],
    country: agencyDetail?.country ?? 'VN',
    areaId: agencyDetail?.areaId ?? '',
    address: agencyDetail?.address ?? '',
    operator: agencyDetail?.operatorId
      ? operatorList.find((operator) => operator.operatorId === agencyDetail.operatorId)?.name
      : operatorList[0]?.name ?? '',
    description: agencyDetail?.description ?? '',
    parentAgencyId: (agencyDetail || isAddSubAgency) ? parentAgencyDetail : user?.agency,
    idCardIssueDate: agencyDetail?.idCardIssueDate ? Utils.formatDateTimeToString(agencyDetail?.idCardIssueDate, 'YYYY-MM-DD') : '',
    idCardPlaceOfIssue: agencyDetail?.idCardPlaceOfIssue ?? '',
    dob: agencyDetail?.dob ? Utils.formatDateTimeToString(agencyDetail?.dob, 'YYYY-MM-DD') : '',
    gender: agencyDetail?.gender ?? 'MALE',
    hsmAgreementUUID: agencyDetail?.hsmAgreementUUID ?? '',
    // hsmPasscode: agencyDetail?.hsmPasscode ?? '',
  }

  const bankInitial = {
    bankCode: agencyBank?.bankCode ?? '',
    bankAccount: agencyBank?.bankAccount ?? '',
    bankBeneficiary: agencyBank?.bankBeneficiary ?? '',
  }

  const agencyCommissionInitial = {
    energyCommissionMode: commission?.energyCommissionMode ?? commissionModeList[0],
    energyCommissionValue:
      DealerHelper.reformatCommissionMode(
        commission?.energyCommissionMode,
        commission?.energyCommissionValue
      ) ?? 0,
  }

  const investmentInfoInitial = {
    energyCommissionForCar: commission?.energyCommissionForCar ?? '',
    energyCommissionForBike: commission?.energyCommissionForBike ?? '',
    overchargeCommissionValue: commission?.overchargeCommissionValue ?? '',
  }

  const saleCommissionInitial = {
    serviceCommission: salesCommission?.serviceCommission ?? null,
    saleCommission:
      salesCommission?.saleCommission?.length
        ? salesCommission.saleCommission?.map((sale, index) => ({
          id: index,
          revenue: sale?.revenue ?? 0,
          discount:
            index === 0
              ? parseFloat((sale?.discount * 100).toFixed(3))
              : Math.round(
                sale?.discount * 100 - salesCommission.saleCommission[index - 1]?.discount * 100
              ) ?? 0,
        }))
        : [{ id: 0, revenue: 0, discount: commissionRateSale ?? 0 }],
    packageCommission:
      salesCommission?.packageCommission?.length
        ? salesCommission.packageCommission?.map((sale, index) => ({
          id: index,
          revenue: sale?.revenue ?? 0,
          discount:
            index === 0
              ? parseFloat((sale?.discount * 100).toFixed(3))
              : Math.round(
                sale?.discount * 100 - salesCommission.packageCommission[index - 1]?.discount * 100
              ) ?? 0,
        }))
        : [{ id: 0, revenue: 0, discount: commissionRateGroup ?? 0 }],
    chargePointCommission:
      salesCommission?.chargePointCommission?.length
        ? salesCommission.chargePointCommission?.map((sale, index) => ({
          id: index,
          revenue: sale?.revenue ?? 0,
          discount:
            index === 0
              ? parseFloat((sale?.discount * 100).toFixed(3))
              : Math.round(
                sale?.discount * 100 - salesCommission.chargePointCommission[index - 1]?.discount * 100
              ) ?? 0,
        }))
        : [{ id: 0, revenue: 0, discount: commissionRateChargePoint ?? 0 }],
    landlordCommission: Array.isArray(salesCommission?.landlordCommission)
      && salesCommission.landlordCommission.length > 0
      && salesCommission?.landlordCommission.some(item => item !== null)
      ? salesCommission.landlordCommission.map((sale) => ({
        key: sale?.key || '',
        name: sale?.name || '',
        value: sale?.value || 0,
      }))
      : Array.isArray(commissionGrounds)
        ? commissionGrounds.map((sale) => ({
          key: sale?.key || '',
          name: sale?.name || '',
          value: sale?.value || 0,
        }))
        : [],
    coinvestorCommission:
      salesCommission?.coinvestorCommission?.length
        ? salesCommission.coinvestorCommission?.map((sale, index) => ({
          id: index,
          revenue: sale?.revenue ?? 0,
          discount:
            index === 0
              ? parseFloat((sale?.discount * 100).toFixed(3))
              : Math.round(
                sale?.discount * 100 - salesCommission.coinvestorCommission[index - 1]?.discount * 100
              ) ?? 0,
        }))
        : [{ id: 0, revenue: 0, discount: commissionRateCoinvestor ?? 0 }],
  }

  const saleEnergyCommissionInitial = {
    energySalesCommissionMode: salesEnergyCommission?.energyCommissionMode ?? commissionModeList[0],
    energySalesCommissionValue:
      DealerHelper.reformatCommissionMode(
        salesEnergyCommission?.energyCommissionMode,
        salesEnergyCommission?.energyCommissionValue
      ) ?? '',
    energyCommissionDuration: salesEnergyCommission?.energyCommissionDuration ?? '',
    stationId: salesEnergyCommission?.stationId ?? '',
  }
  const coinvestorEnergyCommissionInitial = {
    coinvestorEnergyCommissionMode: coinvestorEnergyCommission?.energyCommissionMode ?? commissionModeList[0],
    coinvestorEnergyCommissionValue:
      DealerHelper.reformatCommissionMode(
        coinvestorEnergyCommission?.energyCommissionMode,
        coinvestorEnergyCommission?.energyCommissionValue
      ) ?? '',
    coinvestorEnergyCommissionDuration: coinvestorEnergyCommission?.energyCommissionDuration ?? '',
    coinvestorStationId: coinvestorEnergyCommission?.stationId ?? '',
  }

  const affiliateCommissionInitial = {
    affiliateCommission: [{ id: 0, revenue: 0, discount: commissionRateSale ?? 0 }],
    affiliateEnergyCommissionMode: commissionModeList[0],
    affiliateEnergyCommissionValue: '',
    affiliateEnergyCommissionDuration: '',
  };

  const initialValues = {
    ...agencyInfoInitial,
    ...bankInitial,
    ...agencyCommissionInitial,
    ...investmentInfoInitial,
    ...saleCommissionInitial,
    ...saleEnergyCommissionInitial,
    ...coinvestorEnergyCommissionInitial,
    adminRole: adminRole,
    isEdit: !!agencyDetail,
    isAdminAgency: isAdminAgency,
    isEnergyCommissionOn: false,
    isEnergyCoinvestorCommissionOn: false,
    isVoucherPartner: agencyDetail?.primaryRole === AgencyConstants.AgencyRole.VOUCHER_PARTNER,
  };

  const agencyName = useMemo(() => {
    return t(`abbAgencyRole_${agencyRole}`)
  }, [agencyRole])

  return (
    <div>
      <div className="w-100">
        {BreadcrumbHelper.buildBreadcrumb([
          {
            title: !isAgencyInfo
              ? !adminRole && agencyRole === 'SALE'
                ? `Danh sách ${agencyName} cấp dưới`
                : `Danh sách ${agencyName}`
              : `Thông tin ${agencyName}`,
            onPress: () => {
              router.navigate(-1);
            },
          },
          {
            title: agencyId
              ? isAddSubAgency
                ? `Thêm ${agencyName} cấp dưới`
                : `Sửa ${agencyName}`
              : `Thêm ${agencyName}`
          },
        ])}
      </div>

      <div>
        {isReady ? (
          <div className="m-4 mt-16">
            {isDisabled && (
              <div className="mb-4">
                <CustomAlert
                  icon="fa-regular fa-circle-info fa-2x"
                  title={`Bạn không có quyền chỉnh sửa ${agencyRole === 'SALE' ? 'đại lý' : 'nhà đầu tư'
                    } này`}
                  message={`${agencyRole === 'SALE' ? 'Đại lý' : 'Nhà đầu tư'
                    } này đã phát sinh hợp đồng giao dịch, bạn không có quyền chỉnh sửa`}
                  bgColor="rgba(255, 246, 246, 1)"
                />
              </div>
            )}

            {adminRole && (agencyRole !== 'GROUP' || (agencyRole === 'GROUP' && hasSaleCommission)) && !isAdminAgency && tabs?.length > 1 && (
              <AppTabs
                tabs={tabs}
                activeTab={selectedTab}
                handleClick={handleSelectedTab}
                additionalClassName="pl-0 mt-0 mr-3"
              />
            )}
            <div
              className={`bg-white p-4 ${agencyRole === 'GROUP' || !adminRole || isAdminAgency || tabs?.length === 1
                ? 'rounded-lg'
                : 'rounded-bottom-lg rounded-right-lg'
                }`}
              style={{
                border: !isDisabled ? '1px solid #DBE3EF' : `2px solid ${AppColors.danger}`,
                borderTop: isDisabled
                  ? `2px solid ${AppColors.danger}`
                  : agencyRole === 'GROUP' || !adminRole || tabs?.length === 1
                    ? '1px solid #DBE3EF'
                    : 0,
              }}
            >
              {isAdminAgency && (
                <div className='font-weight-bolder mb-3'
                  style={{
                    fontSize: Utils.returnFontSize(18),
                    color: AppColors.gray[800]
                  }}>
                  Thông tin {(agencyDetail?.name).toLowerCase()}
                </div>
              )}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                enableReinitialize={true}
                noValidate
                onSubmit={(values) => {
                  console.log({ values });
                }}
              >
                {(formikProps) => {
                  refFormik.current = formikProps;

                  return (
                    <form onSubmit={formikProps.handleSubmit}>
                      {selectedTab === t(`agencyInfo_${agencyRole}`) && (
                        <AgencyInfoView
                          formikProps={formikProps}
                          agencyRole={agencyRole}
                          isAdminAgency={isAdminAgency}
                          agencyDetail={agencyDetail}
                          parentAgencyDetail={parentAgencyDetail}
                          isAddSubAgency={isAddSubAgency}
                          adminRole={adminRole}
                          selectedAreaProvince={selectedAreaProvince}
                          setSelectedAreaProvince={setSelectedAreaProvince}
                          selectedAreaDistrict={selectedAreaDistrict}
                          setSelectedAreaDistrict={setSelectedAreaDistrict}
                          bankList={bankList}
                          imageSrc={imageSrc}
                          handleSetImage={handleSetImage}
                          isAgencyInfo={isAgencyInfo}
                          readyToValidData={readyToValidData}
                        />
                      )}

                      {selectedTab === t('Thông tin đầu tư') && (
                        <CoinvestorInvestmentInfo
                          formikProps={formikProps}
                          commissionRateGroup={commissionRateGroup}
                          agencyRole={agencyRole}
                        />
                      )}

                      {selectedTab === t('Hoa hồng bán nhượng quyền') && (
                        <SaleCommissionView
                          formikProps={formikProps}
                          commissionRateSale={commissionRateSale}
                          commissionModeList={commissionModeList}
                          commissionUnit={salesCommissionUnit}
                          setCommissionUnit={setSalesCommissionUnit}
                          isEnergyCommissionOn={isEnergyCommissionOn}
                          handleToggle={handleToggleSale}
                          selectedChargeStation={selectedChargeStation}
                          setSelectedChargeStation={setSelectedChargeStation}
                          readyToValidData={readyToValidData}
                        />
                      )}

                      {(selectedTab === 'Hoa hồng bán liên kết' || selectedTab === t('Hoa hồng bán liên kết')) && (
                        <AffiliateSaleCommissionView
                          formikProps={formikProps}
                          commissionRateSale={commissionRateSale}
                          commissionModeList={commissionModeList}
                          commissionUnit={affiliateCommissionUnit}
                          setCommissionUnit={setAffiliateCommissionUnit}
                          isEnergyCommissionOn={isAffiliateEnergyCommissionOn}
                          handleToggle={handleToggleAffiliate}
                          selectedChargeStation={selectedAffiliateChargeStation}
                          setSelectedChargeStation={setSelectedAffiliateChargeStation}
                          readyToValidData={readyToValidData}
                        />
                      )}

                      {/* {selectedTab === t('packageCommission') && (
                        <PackageCommissionView
                          formikProps={formikProps}
                          commissionRateGroup={commissionRateGroup}
                        />
                      )} */}

                      {/* {selectedTab === t('Hoa hồng bán trụ sạc') && (
                        <ChargepointCommissionView
                          formikProps={formikProps}
                          commissionRateChargePoint={commissionRateChargePoint}
                        />
                      )} */}

                      {/* {selectedTab === t('landlordCommission') && (
                        <LandlordCommissionView
                          formikProps={formikProps}
                          isLandlordCommissionOn={isLandlordCommissionOn}
                          handleToggle={handleToggleLandlord}
                        />
                      )} */}

                      {(selectedTab === t('Hoa hồng đầu tư NQ') || selectedTab === t('Hoa hồng đầu tư')) && (
                        <EnergyCommissionView
                          formikProps={formikProps}
                          commissionModeList={commissionModeList}
                          commissionUnit={commissionUnit}
                          setCommissionUnit={setCommissionUnit}
                        />
                      )}

                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        ) : (
          <div>Loading...</div>
        )}
      </div>
      <footer className="w-100 position-fixed bottom-0 end-0 bg-white py-3 shadow-sm">
        <div className="container-fluid px-4">
          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="secondary"
              className="fw-bold"
              style={{
                fontSize: '13px',
                color: AppColors.gray[800],
                padding: '8px 16px',
              }}
              onClick={handleClose}
            >
              {t('Hủy bỏ')}
            </Button>

            <Button
              variant="success"
              className="fw-bold"
              style={{
                fontSize: '14px',
                padding: '8px 16px',
              }}
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              {agencyDetail ? t('save') : t('Tạo mới')}
            </Button>
          </div>
        </div>
      </footer>
    </div >
  );
}

export default EditAgencyScreen;
